import React from 'react';
import {
  Modal,
  Text,
  BlockStack,
} from '@shopify/polaris';

const RestoreGenerationSceneModal = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  isRestoring 
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={<div style={{padding: '16px'}}>{'Confirm Restore'}</div>}
      primaryAction={{
        content: 'Restore',
        onAction: onConfirm,
        loading: isRestoring,
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: onClose,
        },
      ]}
      footer={<div style={{padding: '16px'}}></div>}
    >
      <BlockStack gap="400">
        <Text>Are you sure you want to restore this generation scene? This action cannot be undone.</Text>
      </BlockStack>
    </Modal>
  );
};

export default RestoreGenerationSceneModal; 